import styled from 'styled-components';
import { SummaryTitleStyled } from '../../SummaryTitleStyled';
import { rem } from 'polished';

export const SummaryTitleOV = styled(SummaryTitleStyled)`
    h3 {
        font-size: ${({ theme }) => theme.fontSizes.h1};
    }

    p {
        font-size: ${({ theme }) => theme.fontSizes.h4};
    }
`;
